<div class="row">
  <div class="col-4"><label>{{title}}</label></div>
  <div class="col-8">
    <div class="form-group">
      <ng2-completer
        [(ngModel)]="contactName"
        [datasource]="contactService"
        [minSearchLength]="0"
        (selected)="select($event)"
        [disabled]="!enabled"
        inputClass="form-control form-control-sm"
      >

      </ng2-completer>
    </div>
  </div>
</div>
